import { styled, SxProps, Theme, Typography, Button } from '@mui/material'

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  padding: '40px 20px 0',
  backgroundColor: '#fff',
  textAlign: 'left',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    padding: '40px 20px 0'
  },
  [theme.breakpoints.down('sm')]: {
    paddingBottom: '40px'
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    padding: '40px 0 0 80px'
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    padding: '40px 20px 0 140px'
  },
  [theme.breakpoints.up('xl')]: {
    padding: '40px 30px 0 60px'
  }
}))

export const Content = styled('div')(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '60%'
  },
  [theme.breakpoints.up('md')]: {
    width: '52%',
    paddingRight: '40px'
  }
}))

export const SliderImageWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '40%'
  },
  [theme.breakpoints.up('md')]: {
    width: '48%'
  }
}))

export const SliderImage = styled('img')(() => ({
  width: '100% !important'
}))

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '2.25rem',
  fontWeight: 700,
  lineHeight: '1.125',
  marginBottom: '10px',
  color: '#1C47CB',
  [theme.breakpoints.up('md')]: {
    fontSize: '2.5rem'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '3.9rem',
    marginBottom: '24px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '4.6rem'
  }
}))

export const TitleHighlight = styled('span')(() => ({
  background: 'linear-gradient(134.15deg, #202CD3 25.28%, #02E39F 94.67%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  textFillColor: 'transparent'
}))

export const Message = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 400,
  fontFamily: '"proxima-nova", sans-serif',
  marginBottom: '30px',
  [theme.breakpoints.up('md')]: {
    fontSize: '0.875rem'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.5rem'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1.5rem'
  }
}))

export const Actions = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '20px',
  marginTop: '10px',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
}))

export const StyledButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(158.55deg, #202CD3 5.3%, #02E39F 102.34%)',
  borderRadius: '75px',
  border: 'none',
  color: '#fff',
  textTransform: 'none',
  fontSize: '0.875rem',
  fontWeight: 600,
  padding: '10px 30px',
  '&:hover': {
    background: 'linear-gradient(158.55deg, #02E39F 5.3%, #202CD3 102.34%)',
    border: 'none'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '0.875rem',
    padding: '8px 34px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.375rem',
    padding: '15px 60px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1.56rem'
  }
})) as typeof Button

export const SliderButtonGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  [theme.breakpoints.up('lg')]: {
    marginTop: '40px'
  }
}))

export const StyledSliderButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '30px',
  height: '30px',
  minWidth: '0',
  background: '#1C47CB',
  borderRadius: '100px',
  color: '#fff',
  '&:hover': {
    background: '#e9edf9',
    color: '#1C47CB'
  },
  [theme.breakpoints.up('md')]: {
    width: '40px',
    height: '40px'
  },
  [theme.breakpoints.up('xl')]: {
    width: '50px',
    height: '50px'
  }
})) as typeof Button

export const TooltipStyles: SxProps<Theme> = {
  '& .MuiTooltip-tooltip': {
    backgroundColor: 'black',
    borderRadius: '1.5rem',
    fontSize: '.85rem',
    lineHeight: 1.8,
    maxWidth: '20rem',
    padding: '1rem'
  },
  '& .MuiTooltip-arrow': {
    color: 'black'
  }
}
